var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8626 9.31302C13.5313 9.5044 12.9771 9.56116 12.0857 9.28814C12.0143 9.26622 11.9361 9.26824 11.8694 9.30052C11.0263 9.70897 9.88848 10.8758 11.3935 12.6824C13.3543 15.036 14.371 11.3905 13.8626 9.31302ZM13.8626 9.31302C14.0079 9.17251 14.2984 8.80234 14.2984 8.44574M3.37099 8.44574C2.77862 7.03359 1.64283 3.39764 3.37099 2.93163C5.656 2.31567 5.14809 9.38718 6.16479 8.44574C7.18149 7.50431 5.14809 -0.363384 7.9077 0.57805C9.82563 1.23235 9.4342 4.94536 8.83827 7.42241C8.77277 7.69448 9.19702 7.93898 9.45352 7.79306C10.6881 7.09048 12.5916 6.69911 14.2984 8.44574M3.37099 8.44574C2.69695 7.31199 2.46077 6.14866 1.29929 6.29391C-1.46032 6.96636 3.69579 16.179 5.14822 18.1291C6.31016 19.6892 5.92285 21.3345 5.58395 21.962M3.37099 8.44574C3.70118 9.00119 3.91319 9.57817 4.42154 10.3179M14.2984 8.44574C15.1215 8.24401 16.7094 8.45919 16.477 10.9338C16.2446 13.4084 14.492 16.2237 13.6448 17.3221C12.725 18.3756 10.9578 20.8861 11.2483 22.5",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.8d10fe6c7167f6cad4723cfaf8c81b81.svg";
export { ForwardRef as ReactComponent };